import httpClient from '../httpClient.js';

const API_REQUEST_MENU = {
    ENDPOINT: '/ModaNet/webServices/VoceMenuService.asmx/getAllMenuEnabled',
    SIGN: { }
}

const getMenu = () => httpClient.simplePost(API_REQUEST_MENU.ENDPOINT)

export {
    getMenu
} 